import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ApplicationService } from '../../../services/application.service';
import { BasePopoverComponent } from '../../../classes/BasePopover';
import { PopoverRef } from '../../../popovers/popover/popover-ref';
import * as moment from 'moment';
import { FinanceDataService } from '../../../services/finance-data.service';
import { catchError, ignoreElements, share } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-finance-details',
    templateUrl: './finance-details.component.html',
    styleUrls: ['./finance-details.component.scss'],
    viewProviders: [ApiService],
})
export class FinanceDetailsComponent extends BasePopoverComponent implements OnInit {
    LABELS: any;
    TEXTS: any;
    MONTHS: string[];

    financeData$ = this.financeDataService.getFinancialTrend().pipe(share());
    financeDataError$: Observable<boolean> = this.financeData$.pipe(
        ignoreElements(),
        catchError(() => of(true))
    );

    finance = {
        trend: 0,
        amount: 0,
        percent: 0,
        from: null,
        to: null,
    };

    config = {
        notify: 0,
    };

    infoVisible = false;

    constructor(
        protected popoverRef: PopoverRef,
        private application: ApplicationService,
        private financeDataService: FinanceDataService,
        private translate: TranslateService
    ) {
        super(popoverRef);
    }

    ngOnInit() {
        this.translate.get('screens.dashboard.months').subscribe((monthsList: string[]) => {
            this.MONTHS = monthsList;
        });
        this.translate.get('screens.dashboard.financeDetail.labels').subscribe((labels: any) => {
            this.LABELS = labels;
        });

        this.translate.get('screens.dashboard.financeDetail.texts').subscribe((texts: any) => {
            this.TEXTS = texts;
        });
    }

    /**
     * Format the end date for beginning of the current year
     * @param date
     */
    formatStartDate(date: Date): string {
        if (this.application.isDemoMode()) {
            const now = new Date();
            return `01.01.${now.getFullYear()}`;
        }
        return this.formatDate(date);
    }

    /**
     * Format the end date for end of the current year
     * @param date
     */
    formatEndDate(date: Date): string {
        if (this.application.isDemoMode()) {
            const now = new Date();
            return `31.12.${now.getFullYear()}`;
        }
        return this.formatDate(date);
    }

    /**
     * Opens a static link
     */
    openLink(): void {
        window.open('https://www.eon.de/de/meineon/start.html');
    }

    /**
     * Format date wrapper
     * @param date
     * @private
     */
    private formatDate(date: Date): string {
        const parsedDate = moment(date);
        const currentLang = this.translate.currentLang;
        return parsedDate.locale(currentLang).format('DD. MMM YYYY');
    }
}
